// src/api/api.js
import axios from "axios";

// Set up the base URL for the API. CRA env vars are build-time only, so keep
// a hostname fallback for builds where REACT_APP_API_BASE_URL is not injected.
const defaultBaseUrl =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://localhost:3000"
    : "https://api.tuvpak.com";
const BASE_URL = (process.env.REACT_APP_API_BASE_URL || defaultBaseUrl).replace(/\/+$/, "");
const API_NOTES = "/api/v1/";
// Static template images (logo, bars, default footer logos) served by the backend.
export const TEMPLATE_ASSETS_BASE_URL = `${BASE_URL}/templates/assets`;
// const GET_USER_ALL_NOTES = `${API_NOTES}get_user_all_notes`
// const DELETE_USER_NOTES = `${API_NOTES}delete_user_note`
// const ADD_USER_NOTE = `${API_NOTES}add_user_note`
const AUTH_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NmFkN2JmY2ExZWQzMzBiYTYwYWI1OSIsImVtYWlsIjoiYWhzYW5yYWhtYW4xMzdAZ21haWwuY29tIiwiaWF0IjoxNzM1OTc2Mjg1fQ.MpQXPgqvcExn8iE7D9D-HwKeN5CV3ULTRtt4nrRyIn0";

/// ADMIN LOGIN
const ADMIN_LOGIN_API = `${API_NOTES}user_login`;
/// CREATE USER CARD
const CREATE_USER_CARD = `${API_NOTES}create_user_card`;
/// USER CARD LIST
const USER_CARD_LIST = `${API_NOTES}card_list`;
/// Upload Photo Card User
const UPLOAD_PHOTO_CARD_USER = `${API_NOTES}upload_photo_card_user`;
/// CERTIFICATION endpoints
const CERTIFICATION_LIST_API = `${API_NOTES}certification_list`;
const CREATE_CERTIFICATION_API = `${API_NOTES}create_certification`;
const SEARCH_CERTIFICATION_API = `${API_NOTES}search_certification`;
const UPDATE_CERTIFICATION_API = `${API_NOTES}update_certification`;
const DELETE_CERTIFICATION_API = `${API_NOTES}delete_certification`;
const UPDATE_MY_PROFILE_API = `${API_NOTES}update_my_profile`;
const USER_LIST_API = `${API_NOTES}user_list`;
const CREATE_USER_API = `${API_NOTES}create_user`;
const UPDATE_USER_API = `${API_NOTES}update_user`;
const DELETE_USER_API = `${API_NOTES}delete_user`;
const CERTIFICATE_TEMPLATES_API = `${API_NOTES}certificate_templates`;
const GENERATE_CERTIFICATE_API = `${API_NOTES}generate_certificate`;
const GET_CERTIFICATION_API = `${API_NOTES}get_certification`;
const CERTIFICATE_ASSETS_API = `${API_NOTES}certificate_assets`;
const CREATE_CERTIFICATE_ASSET_API = `${API_NOTES}create_certificate_asset`;
const DELETE_CERTIFICATE_ASSET_API = `${API_NOTES}delete_certificate_asset`;
const CERTIFICATE_CONFIG_API = `${API_NOTES}certificate_config`;
const SAVE_CERTIFICATE_FOOTER_API = `${API_NOTES}save_certificate_footer`;
const DELETE_CERTIFICATE_FOOTER_API = `${API_NOTES}delete_certificate_footer`;
const UPDATE_CERTIFICATE_DEFAULTS_API = `${API_NOTES}update_certificate_defaults`;
const INVOICE_LIST_API = `${API_NOTES}invoice_list`;
const GET_INVOICE_API = `${API_NOTES}get_invoice`;
const CREATE_INVOICE_API = `${API_NOTES}create_invoice`;
const UPDATE_INVOICE_API = `${API_NOTES}update_invoice`;
const PRINT_INVOICE_API = `${API_NOTES}print_invoice`;
const DELETE_INVOICE_API = `${API_NOTES}delete_invoice`;
const NEXT_INVOICE_NO_API = `${API_NOTES}next_invoice_no`;

// Create an Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    authorization: AUTH_TOKEN,
  },
});

// Create an Axios instance factory
const createApi = (userAuthToken) =>
  axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      authorization: "bazzer " + userAuthToken,
    },
  });

// Create an Axios instance factory for file uploads
// NOTE: Do NOT set Content-Type here — axios must auto-set it with the
// multipart boundary when it detects a FormData body.
const createApiForUploadFile = (userAuthToken) =>
  axios.create({
    baseURL: BASE_URL,
    headers: {
      authorization: "bazzer " + userAuthToken,
    },
  });

// Example PUT request function to update a note
export const searchDocFromAPI = async (body) => {
  try {
    const response = await api.post(SEARCH_CERTIFICATION_API, body);
    return response.data;
  } catch (error) {
    console.error("Error searching Doc:", error);
    if (!error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Example PUT request function to update a note
export const requestToLogin = async (body) => {
  try {
    const response = await api.post(ADMIN_LOGIN_API, body);
    return response.data;
  } catch (error) {
    console.error("ADMIN_LOGIN_API:", error);
    if (!error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Example PUT request function to update a note
export const requestToCreateUserCard = async (body, userAuthToken) => {
  try {
     console.log("requestToCreateUserCard: ", body);
    const api = createApiForUploadFile(userAuthToken);
    const formData = new FormData();
    formData.append("profile_image", body.profile_image);
    const uploadFileResponse = await api.post(UPLOAD_PHOTO_CARD_USER, formData);
    if (uploadFileResponse.data.success) {
      body.profile_image = uploadFileResponse.data.file_name;
       console.log("requestToCreateUserCard: ", body);
      const response = await api.post(CREATE_USER_CARD, body);
      return response.data;
    } else {
      return uploadFileResponse.data;
    }
  } catch (error) {
    console.error("CREATE_USER_CARD:", error);
    if (!error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Example GET request function to fetch notes
export const fetchAllCertificationList = async (body, userAuthToken) => {
  try {
    const api = createApi(userAuthToken);
    const response = await api.post(USER_CARD_LIST, body);
    return response.data;
  } catch (error) {
    console.error("fetch All Certification List:", error);
    if (!error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Fetch paginated certification list
export const fetchCertificationListAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(CERTIFICATION_LIST_API, body);
    return response.data;
  } catch (error) {
    console.error("fetchCertificationListAPI:", error);
    if (error.response && !error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Create a new certification — server auto-detects file and uploads it
export const createCertificationAPI = async (body, userAuthToken) => {
  try {
    const uploadApi = createApiForUploadFile(userAuthToken); // must use multipart instance
    const formData = new FormData();
    formData.append("certification_search_id", body.certification_search_id);
    formData.append("issue_date", body.issue_date);
    formData.append("expire_date", body.expire_date);
    formData.append("certification_url", body.file); // File object — server handles upload
    const response = await uploadApi.post(CREATE_CERTIFICATION_API, formData);
    console.log("createCertificationAPI response:", response.data);
    return response.data;
  } catch (error) {
    console.error("createCertificationAPI error:", error?.response?.data || error.message);
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred.",
    };
  }
};

// Search certification by search ID
export const searchCertificationAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(SEARCH_CERTIFICATION_API, body);
    return response.data;
  } catch (error) {
    console.error("searchCertificationAPI:", error);
    if (error.response && !error.response.data.status) {
      return error.response.data;
    } else {
      throw error;
    }
  }
};

// Update an existing certification — server auto-detects file vs path for certification_url
export const updateCertificationAPI = async (body, userAuthToken) => {
  try {
    const uploadApi = createApiForUploadFile(userAuthToken);
    const formData = new FormData();
    formData.append("id", body.id);
    formData.append("certification_search_id", body.certification_search_id);
    formData.append("issue_date", body.issue_date);
    formData.append("expire_date", body.expire_date);
    // If a new file was selected send the File object, otherwise send the existing URL string
    formData.append("certification_url", body.file ? body.file : body.certification_url || "");
    const response = await uploadApi.post(UPDATE_CERTIFICATION_API, formData);
    console.log("updateCertificationAPI response:", response.data);
    return response.data;
  } catch (error) {
    console.error("updateCertificationAPI error:", error?.response?.data || error.message);
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred.",
    };
  }
};

export const deleteCertificationAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(DELETE_CERTIFICATION_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const updateMyProfileAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(UPDATE_MY_PROFILE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const fetchUserListAPI = async (userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(USER_LIST_API, {});
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const createUserAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(CREATE_USER_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const updateUserAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(UPDATE_USER_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const deleteUserAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(DELETE_USER_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const fetchCertificateTemplatesAPI = async (userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.get(CERTIFICATE_TEMPLATES_API);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const generateCertificateAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(GENERATE_CERTIFICATE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const fetchCertificationByIdAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(GET_CERTIFICATION_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// Saved signatures and company seals for certificate templates
export const fetchCertificateAssetsAPI = async (userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.get(CERTIFICATE_ASSETS_API);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// body: { asset_type: "signature"|"seal", name, file?: File, image_data?: "data:image/png;base64,..." }
export const createCertificateAssetAPI = async (body, userAuthToken) => {
  try {
    if (body.file) {
      const uploadApi = createApiForUploadFile(userAuthToken);
      const formData = new FormData();
      formData.append("asset_type", body.asset_type);
      formData.append("name", body.name);
      formData.append("asset_image", body.file);
      const response = await uploadApi.post(CREATE_CERTIFICATE_ASSET_API, formData);
      return response.data;
    }
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(CREATE_CERTIFICATE_ASSET_API, {
      asset_type: body.asset_type,
      name: body.name,
      image_data: body.image_data,
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const deleteCertificateAssetAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(DELETE_CERTIFICATE_ASSET_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// Shared certificate configuration: assets, saved footers and defaults
// -> { success, assets, footers: [{id, name, companies, website, email, gmail, is_default}],
//      defaults: { inspected_by_asset_id, approved_by_asset_id, company_seal_asset_id, footer_id } }
export const fetchCertificateConfigAPI = async (userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.get(CERTIFICATE_CONFIG_API);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// body: { id?, name, companies: [{key, name, url, asset_id}], website, email, gmail }
// Without `id` a new footer is created, with `id` the saved footer is updated.
export const saveCertificateFooterAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(SAVE_CERTIFICATE_FOOTER_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const deleteCertificateFooterAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(DELETE_CERTIFICATE_FOOTER_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// body: any of { inspected_by_asset_id, approved_by_asset_id, company_seal_asset_id, footer_id }
export const updateCertificateDefaultsAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(UPDATE_CERTIFICATE_DEFAULTS_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// --- Invoices / quotations (admin only) ------------------------------------
export const fetchInvoiceListAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(INVOICE_LIST_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const getInvoiceAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(GET_INVOICE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const nextInvoiceNoAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(NEXT_INVOICE_NO_API, body || {});
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const createInvoiceAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(CREATE_INVOICE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const updateInvoiceAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(UPDATE_INVOICE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const printInvoiceAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(PRINT_INVOICE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

export const deleteInvoiceAPI = async (body, userAuthToken) => {
  try {
    const apiInstance = createApi(userAuthToken);
    const response = await apiInstance.post(DELETE_INVOICE_API, body);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
    };
  }
};

// export const addNoteFromApi = async (body) => {
//   try {
//     const response = await api.post(ADD_USER_NOTE,
//        body
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error adding note:", error);
//     if(!error.response.data.status){
//       return error.response.data
//     }else {
//       throw error;
//     }

//   }
// };

// // Example PUT request function to update a note
// export const updateNote = async (noteId, noteData) => {
//   try {
//     const response = await api.put(`/notes/${noteId}`, noteData); // Example endpoint
//     return response.data;
//   } catch (error) {
//     console.error("Error updating note:", error);
//     if(!error.response.data.status){
//       return error.response.data
//     }else {
//       throw error;
//     }
//   }
// };

// // Example DELETE request function to delete a note
// export const deleteNoteFromAPI = async (body) => {
//   try {
//     const response = await api.delete(DELETE_USER_NOTES,{
//       data: body, // Include the body in the `data` property
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting note:", error);
//     if(!error.response.data.status){
//       return error.response.data
//     }else {
//       throw error;
//     }
//   }
// };
